import React from 'react';
import cx from 'classnames';

import { ReactComponent as ExpandIcon } from 'Public/static/images/expand-icon.svg';
import { ReactComponent as ShrinkIcon } from 'Public/static/images/shrink-icon.svg';

import styles from './MapExpanderControl.module.scss';

export interface MapExpanderControlProps {
	isExpanded: boolean;
	onClick: () => void;
}

const MapExpanderControl: React.FC<MapExpanderControlProps> = ({ isExpanded, onClick }) => {
	return (
		<div className={styles.controlContainerExpand}>
			<div className={cx([styles.expandControls])} id="custom-map-controls-expand">
				<button
					aria-label={isExpanded ? 'Shrink map' : 'Expand map'}
					className={styles.expand}
					onClick={onClick}
					tabIndex={0}
				>
					{isExpanded ? <ShrinkIcon height={16} /> : <ExpandIcon height={16} />}
				</button>
			</div>
		</div>
	);
};

export default MapExpanderControl;
